// React Query keys. `root` is the invalidation umbrella used by pages after
// create/edit/delete (matches every key below by prefix).
export const TOURNAMENT_QUERY_KEYS = {
  root: ['tournaments'] as const,
  list: (params: unknown) => ['tournaments', 'list', params] as const,
  detail: (id: string) => ['tournaments', 'detail', id] as const,
  moderatorOptions: ['tournaments', 'moderator-options'] as const,
  context: ['tournaments', 'context'] as const,
}
